export default __webpack_public_path__ + "static/media/tokenImageXbank.ef44d353.svg";